import React, { useEffect } from 'react';

import type { OptionsFromRequest } from '../../../../core/system/rendering/types.js';
import type { ByfunnFrapiBioPage } from '../../../types/frapi-types.js';

import { usePulseContext } from '../../../../core/mandatory-integrations/pulse/PulseProvider.js';
import { withByfunnPulse, trackTagPageView } from '../../../pulse/index.js';
import { AuthorResults } from './AuthorResults.js';
import Footer from '../../components/commonComponents/Footer.js';
import Navigation from '../../components/commonComponents/Navigation/Navigation.js';
import AuthorInfo from './AuthorInfo.js';
import BackButton from '../../../../core/react/components/BackButton.js';
import { ListsProvider } from '../../components/saving/ListsProvider.js';

export type BioPageProps = {
  data: ByfunnFrapiBioPage;
  options: OptionsFromRequest;
};

const AuthorBioPage: React.FC<BioPageProps> = ({ data, options }) => {
  const { siteVersion, currentUrl, isHermesApp } = options;
  const { author, authorContent } = data;
  const { trackViewListing, registerElementViewTracking } = usePulseContext();

  useEffect(() => {
    data.author.slug &&
      trackTagPageView(trackViewListing, currentUrl, data.author.slug);

    registerElementViewTracking({
      object: {
        page: {
          id: 'author-bio',
          type: 'Listing',
        },
      },
    });
  }, [trackViewListing, registerElementViewTracking, currentUrl, data]);

  const isMobile = siteVersion === 'phone';

  return (
    <ListsProvider>
      <div className={`${siteVersion}-front`}>
        <div className="author-bio-page">
          <Navigation fullWidth={!isMobile} isHermesApp={isHermesApp} />
          <BackButton pulseId="authorbio:previous-page">
            <span className="icon"></span>
            <span className="label">tilbake</span>
          </BackButton>
          <AuthorInfo author={author} isMobile={isMobile} />
          <AuthorResults
            currentPage={options.page ? parseInt(options.page) : 1}
            collection={authorContent.articles}
            resultsCount={authorContent.resultsCount}
            isMobile={isMobile}
            slug={data.author.slug || ''}
          />
        </div>
        <Footer isMobile={isMobile} />
      </div>
    </ListsProvider>
  );
};

const AuthorBioWithPulse = withByfunnPulse(AuthorBioPage);

export { AuthorBioWithPulse as AuthorBioPage };
